import { render, staticRenderFns } from "./SelectDelegate.vue?vue&type=template&id=269f0922"
import script from "./SelectDelegate.vue?vue&type=script&lang=ts"
export * from "./SelectDelegate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports